class AtlasCountdown extends HTMLElement {
  connectedCallback() {
    this.hoursNode = this.querySelector('[data-hours]');
    this.minutesNode = this.querySelector('[data-minutes]');
    this.secondsNode = this.querySelector('[data-seconds]');

    const configuredEnd = this.dataset.end?.trim();
    const durationHours = Number(this.dataset.duration || 16);
    const storageKey = `atlas-countdown-${this.dataset.section}`;
    const storedEnd = Number(window.localStorage.getItem(storageKey));

    if (configuredEnd) {
      this.endTime = new Date(configuredEnd).getTime();
    } else if (storedEnd > Date.now()) {
      this.endTime = storedEnd;
    } else {
      this.endTime = Date.now() + durationHours * 60 * 60 * 1000;
      window.localStorage.setItem(storageKey, String(this.endTime));
    }

    this.render();
    this.timer = window.setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  render() {
    let remaining = Math.max(0, this.endTime - Date.now());

    if (remaining === 0 && !this.dataset.end?.trim()) {
      this.endTime = Date.now() + Number(this.dataset.duration || 16) * 60 * 60 * 1000;
      window.localStorage.setItem(`atlas-countdown-${this.dataset.section}`, String(this.endTime));
      remaining = this.endTime - Date.now();
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.hoursNode.textContent = String(hours).padStart(2, '0');
    this.minutesNode.textContent = String(minutes).padStart(2, '0');
    this.secondsNode.textContent = String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('atlas-countdown')) {
  customElements.define('atlas-countdown', AtlasCountdown);
}
